import { SUserService, SGeoService } from '@slg/web-customer-shared';

type AuthState = {
  profile: Record<string, any>;
  authToken: string;
  location: string | null;
};

export default {
  namespaced: true,
  state: {
    profile: {
      allowedPayByInvoice: '',
      billingFirstName: '',
      billingLastName: '',
      city: '',
      companyName: '',
      anotherPassengerList: [],
      country: '',
      devices: [],
      email: '',
      firstName: '',
      language: '',
      lastName: '',
      marketingSubscription: false,
      phone: '',
      postalCode: '',
      street: '',
      customerDeletionRequestedTime: null,
      nightRiderCardNumber: null,
      communeCoordinates: [],
      linkedNrCardExpirationAt: null,
      dismissExpirationReminder: false,
    },
    authToken: '',
    location: null,
  } as AuthState,
  mutations: {
    setAuthToken(state: AuthState, data: string) {
      localStorage.setItem('authToken', data);
      state.authToken = data;
    },
    setLocation(state: AuthState, ip: string) {
      const location = ip.split(';')[1];
      localStorage.setItem('location', location);
      state.location = location;
    },
    setUserProfileInfo(state: AuthState, data: Record<string, any>) {
      const keys = Object.keys(state.profile);
      keys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          state.profile[key] = data[key];
        }
      });
      const nightCardProfileFields = [
        'nightRiderCardNumber',
        'linkedNrCardExpirationAt',
        'dismissExpirationReminder',
        'communeCoordinates',
      ];
      nightCardProfileFields.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          state.profile[key] = data[key];
        }
      });
      state.profile.anotherPassengerList = (state.profile.anotherPassengerList || [])
        .sort((a: { lastUsedDateTime: number }, b: { lastUsedDateTime: number }) => b.lastUsedDateTime - a.lastUsedDateTime);
    },
    clearAuthTokenAndProfileInfo(state: AuthState) {
      state.authToken = '';
      localStorage.removeItem('authToken');
      const keys = Object.keys(state.profile);
      keys.forEach((key) => {
        state.profile[key] = null;
      });
    },
  },
  actions: {
    async populateUserProfileInfo({ commit }: { commit: (type: string, payload?: unknown) => void }) {
      try {
        const { data } = await SUserService.getProfile();
        commit('setUserProfileInfo', data);
      } catch (e) {
        //
      }
    },
    async setGeoData({ commit }: { commit: (type: string, payload?: unknown) => void }) {
      try {
        const ip = await SGeoService.initIP();
        commit('setLocation', ip.data);
      } catch (e) {
        //
      }
    },
  },
  getters: {
    getIsAuth: (state: AuthState) => !!state.authToken,
    getLocation: (state: AuthState) => state.location || localStorage.getItem('location'),
    getAuthToken: (state: AuthState) => state.authToken,
    getUserProfile: (state: AuthState) => state.profile,
    getFirstName: (state: AuthState) => state.profile.firstName,
    getFirstLetters: (state: AuthState) => (state.profile.firstName && state.profile.lastName)
      && `${state.profile?.firstName[0]}${state.profile?.lastName[0]}`,
    getFullName: (state: AuthState) => `${state.profile.firstName} ${state.profile.lastName}`,
    getUserDetailsForBookingDetails: (state: AuthState) => ({
      phone: state.profile.phone,
      firstName: state.profile.firstName,
      lastName: state.profile.lastName,
      email: state.profile.email,
      customerDeletionRequestedTime: state.profile.customerDeletionRequestedTime,
    }),
    getAnotherPassengerList: (state: AuthState) => state.profile.anotherPassengerList,
    getNightRiderCardNumber: (state: AuthState) => state.profile.nightRiderCardNumber || null,
    getLinkedNrCardExpirationAt: (state: AuthState) => state.profile.linkedNrCardExpirationAt ?? null,
    getDismissExpirationReminder: (state: AuthState) => state.profile.dismissExpirationReminder,
  },
};
